import React from "react";

const sections = [
  {
    id: "responsable",
    title: "1. Identificación del Responsable",
    paragraphs: [
      "MOU SOLUTIONS S.A.S., identificada con NIT 901935902-1 y domiciliada en Fusagasugá, Cundinamarca, Colombia, es responsable del tratamiento de los datos personales recolectados, almacenados y administrados a través de su plataforma digital MEU Aliado y de los canales de atención habilitados para personas y empresas.",
    ],
    lists: [
      {
        title: "Datos de contacto",
        items: [
          "Dirección: Cra 8 #5-59 Oficina 506, Fusagasugá, Cundinamarca",
          "Correo electrónico de contacto: protecciondatos@meu-aliado.com",
          "Línea de atención al usuario: +57 322 908 0554",

        ],
      },
    ],
  },
  {
    id: "principios",
    title: "2. Principios que orientan el tratamiento",
    paragraphs: [
      "El tratamiento de datos personales realizado por MOU SOLUTIONS S.A.S. se rige por los principios establecidos en la Ley 1581 de 2012, el Decreto 1377 de 2013 y la normatividad aplicable al sector financiero y de finanzas abiertas en Colombia.",
      "En consecuencia, garantizamos que el tratamiento se efectuará con sujeción a los principios de legalidad, finalidad, libertad, veracidad, transparencia, acceso y circulación restringida, seguridad y confidencialidad.",
    ],
  },
  {
    id: "finalidades",
    title: "3. Finalidades del tratamiento",
    paragraphs: [
      "Los datos personales se recolectan y administran para cumplir las siguientes finalidades relacionadas con la prestación de nuestros servicios auxiliares financieros:",
    ],
    lists: [
      {
        items: [
          "Validar la identidad de los usuarios y habilitar su acceso a la plataforma MEU Aliado.",
          "Centralizar y presentar información financiera proveniente de entidades aliadas, terceros receptores de datos y fuentes públicas autorizadas.",
          "Gestionar simuladores, solicitudes y preaprobaciones de productos como CDT, FIC, pensiones voluntarias y soluciones de vinculación financiera.",
          "Monitorear el comportamiento transaccional y ofrecer recomendaciones personalizadas de ahorro e inversión.",
          "Dar cumplimiento a obligaciones contractuales, contables, regulatorias y de reporte ante autoridades de supervisión.",
          "Gestionar el relacionamiento comercial, la atención de PQR y campañas de educación financiera.",
          "Implementar mecanismos antifraude, gestión de riesgos y controles SARLAFT.",
        ],
      },
    ],
  },
  {
    id: "datos-tratados",
    title: "4. Datos personales objeto de tratamiento",
    paragraphs: [
      "En desarrollo de nuestras actividades tratamos las siguientes categorías de datos, siempre con autorización previa, expresa e informada del titular o en los eventos previstos por la ley:",
    ],
    lists: [
      {
        items: [
          "Datos de identificación y contacto: nombres, apellidos, tipo y número de documento, fecha de expedición, correo electrónico, dirección, teléfono, ciudad y país.",
          "Datos financieros y patrimoniales: ingresos, activos, pasivos, historial de productos financieros, extractos consolidados, tasas y condiciones pactadas.",
          "Datos transaccionales y de comportamiento financiero: consumos, aportes, redenciones, cumplimiento de obligaciones y hábitos de ahorro o inversión.",
          "Datos laborales y socioeconómicos: ocupación, actividad económica, información empresarial, perfiles de riesgo y segmentación.",
          "Datos sensibles relacionados con autenticación reforzada, métricas de seguridad y preferencias de accesibilidad digital. Estos datos se tratarán con las medidas de protección reforzada y solamente cuando sean indispensables para prevenir fraudes y proteger al titular.",
        ],
      },
    ],
  },
  {
    id: "autorizacion",
    title: "5. Autorización y medios de recolección",
    paragraphs: [
      "La autorización del titular se obtiene por medios digitales, formularios electrónicos, grabaciones de voz o documentos físicos, según el canal utilizado. Cuando se empleen integraciones de finanzas abiertas, MOU SOLUTIONS S.A.S. asegura que los terceros aliados cuenten con autorización legítima y estándares de seguridad equivalentes.",
      "Los usuarios pueden consultar en cualquier momento el histórico de autorizaciones otorgadas a través de la sección de privacidad disponible en la plataforma.",
    ],
  },
  {
    id: "derechos",
    title: "6. Derechos de los titulares",
    paragraphs: [
      "Los titulares de los datos personales podrán ejercer en cualquier momento los derechos consagrados en la legislación colombiana, especialmente los previstos en el artículo 8 de la Ley 1581 de 2012:",
    ],
    lists: [
      {
        items: [
          "Conocer, actualizar y rectificar sus datos personales frente a MOU SOLUTIONS S.A.S.",
          "Solicitar prueba de la autorización otorgada.",
          "Ser informados sobre el uso que se ha dado a sus datos.",
          "Presentar quejas ante la Superintendencia de Industria y Comercio por infracciones a la normatividad.",
          "Revocar la autorización y/o solicitar la supresión del dato cuando no se respeten los principios, derechos y garantías constitucionales y legales.",
          "Acceder en forma gratuita a sus datos personales a través de los canales habilitados.",
        ],
      },
    ],
  },
  {
    id: "procedimientos",
    title: "7. Procedimiento para consultas y reclamos",
    paragraphs: [

      "Las consultas y reclamos relacionados con el tratamiento de datos personales podrán presentarse por cualquiera de los siguientes canales: (i) correo electrónico protecciondatos@meu-aliado.com, (ii) formulario de contacto disponible en www.meu-aliado.com, o (iii) la línea telefónica +57 322 908 0554 en horario hábil.",

      "Las solicitudes serán atendidas en los términos establecidos en el Decreto 1377 de 2013: las consultas dentro de los diez (10) días hábiles siguientes a su recepción y los reclamos dentro de los quince (15) días hábiles siguientes, prorrogables de conformidad con la ley.",
    ],
  },
  {
    id: "transferencias",
    title: "8. Transferencias y transmisiones a terceros",
    paragraphs: [
      "MOU SOLUTIONS S.A.S. podrá transferir o transmitir datos personales a aliados comerciales, entidades financieras, proveedores tecnológicos, operadores de servicios de custodia de información y autoridades competentes, siempre que dichas transferencias se relacionen con las finalidades autorizadas y se garanticen medidas contractuales de seguridad, confidencialidad y cumplimiento regulatorio.",
      "Cuando los datos personales deban circular hacia jurisdicciones con niveles de protección inferiores a los colombianos, se implementarán cláusulas contractuales y salvaguardas técnicas que aseguren un nivel adecuado de protección.",
    ],
  },
  {
    id: "seguridad",
    title: "9. Medidas de seguridad",
    paragraphs: [
      "Adoptamos controles técnicos, humanos y administrativos orientados a salvaguardar la integridad, disponibilidad y confidencialidad de la información, entre ellos: encriptación de datos en tránsito y en reposo, autenticación multifactor opcional, monitoreo permanente de eventos, políticas de acceso por roles y pruebas de resiliencia operacional.",
      "Adicionalmente, se ejecutan procesos periódicos de evaluación de proveedores y auditorías internas alineadas con estándares de seguridad de la información (ISO/IEC 27001) y mejores prácticas de gestión de riesgos en entornos Fintech.",
    ],
  },
  {
    id: "retencion",
    title: "10. Conservación y supresión de datos",
    paragraphs: [
      "Los datos personales serán conservados únicamente durante el tiempo necesario para cumplir con las finalidades autorizadas y con las obligaciones legales y contractuales aplicables. Una vez cumplido dicho término, se eliminarán o anonimizarán de manera segura, salvo cuando exista un deber legal o contractual que requiera su conservación.",
    ],
  },
  {
    id: "actualizaciones",
    title: "11. Actualizaciones de la política",
    paragraphs: [
      "MOU SOLUTIONS S.A.S. podrá modificar la presente política en cualquier momento. Las actualizaciones se comunicarán a través del sitio web www.meu-aliado.com, correo electrónico registrado y demás canales oficiales. Cuando el cambio implique variaciones sustanciales en la finalidad del tratamiento, se solicitará nuevamente la autorización del titular.",
    ],
  },
];

const TableOfContents = () => (
  <nav className="bg-white/80 backdrop-blur-md border border-[#C7D4E3] rounded-2xl p-6 shadow-lg">
    <h2 className="text-lg font-semibold text-[#003B8E] mb-4">Contenido de la política</h2>
    <ul className="space-y-3 text-sm font-medium text-[#0F172A]">
      {sections.map((section) => (
        <li key={section.id}>
          <a
            href={`#${section.id}`}
            className="transition-colors hover:text-[#0054c9] focus:text-[#0054c9] focus:outline-none"
          >
            {section.title}
          </a>
        </li>
      ))}
    </ul>
  </nav>
);

const PoliticaTratamientoDatos = () => {
  return (
    <div className="bg-[#E8F2F4] text-[#0F172A] min-h-screen">
      <div className="relative overflow-hidden bg-gradient-to-br from-[#0054c9] via-[#023680] to-[#010e2f] text-white">
        <div className="absolute inset-0 bg-[url('https://www.meu-aliado.com/static/media/hero-pattern.2c1b9c88.svg')] opacity-10" aria-hidden />
        <div className="relative z-10 max-w-6xl mx-auto px-6 py-24">
          <p className="uppercase tracking-[0.4em] text-xs font-semibold mb-6 text-[#D7E3FF]">Protección de datos personales</p>
          <h1 className="text-4xl md:text-5xl font-extrabold mb-6 leading-tight">
            Política de Tratamiento de Datos Personales
          </h1>
          <p className="text-lg md:text-xl max-w-2xl text-[#E8EEFF]">
            Este documento establece las directrices mediante las cuales MOU SOLUTIONS S.A.S. protege la información que nos confían las personas y empresas usuarias de MEU Aliado.
          </p>
          <div className="mt-8 inline-flex flex-col sm:flex-row sm:items-center gap-4 text-sm text-[#E8EEFF]/90">
            <span className="bg-white/10 border border-white/20 px-4 py-2 rounded-full">Vigencia desde: 10 de febrero de 2025</span>
            <span className="bg-white/10 border border-white/20 px-4 py-2 rounded-full">Última actualización: 18 de febrero de 2025</span>
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-6 py-16 grid grid-cols-1 lg:grid-cols-[320px_minmax(0,1fr)] gap-10">
        <div className="order-2 lg:order-1">
          <TableOfContents />
          <div className="mt-8 bg-white border border-[#C7D4E3] rounded-2xl p-6 shadow-sm">
            <h2 className="text-base font-semibold text-[#003B8E] mb-3">Contacto para ejercer derechos</h2>
            <p className="text-sm leading-relaxed text-[#0F172A]/80">
              Escríbenos a <a href="mailto:protecciondatos@meu-aliado.com" className="text-[#0054c9] font-semibold">protecciondatos@meu-aliado.com</a> o llama al
              <span className="font-semibold"> +57 322 908 0554</span>. También puedes radicar tu solicitud desde la opción "Gestión de privacidad" en la plataforma MEU Aliado.

            </p>
          </div>
        </div>

        <div className="space-y-12 order-1 lg:order-2">
          {sections.map((section) => (
            <section key={section.id} id={section.id} className="bg-white border border-[#C7D4E3] rounded-3xl p-8 shadow-sm scroll-mt-32">
              <h2 className="text-2xl font-bold text-[#003B8E] mb-4">{section.title}</h2>
              <div className="space-y-4 text-base leading-relaxed">
                {section.paragraphs.map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
                {section.lists?.map((list, listIndex) => (
                  <div key={listIndex} className="space-y-2">
                    {list.title && <h3 className="text-lg font-semibold text-[#0054c9]">{list.title}</h3>}
                    <ul className="list-disc list-inside space-y-2">
                      {list.items.map((item, itemIndex) => (
                        <li key={itemIndex}>{item}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </section>
          ))}

          <section className="bg-[#003B8E] text-white rounded-3xl p-8 shadow-lg">
            <h2 className="text-2xl font-bold mb-4">Compromiso con las finanzas abiertas</h2>
            <p className="text-base leading-relaxed text-[#E8EEFF]">
              Como auxiliar del ecosistema Fintech colombiano, MEU Aliado adopta prácticas responsables de intercambio de información financiera alineadas con los lineamientos de finanzas abiertas. Garantizamos que la interoperabilidad con nuestros aliados se realiza bajo estándares de consentimiento informado, trazabilidad de accesos y transparencia sobre los usos autorizados de los datos.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PoliticaTratamientoDatos;
